const words = {
  spanish: {
    title: "Reservas",
    name: "Nombre",
    email: "Correo Electrónico",
    phone: "Teléfono",
    quantity: "Cantidad",
    arrival: "Fecha de Llegada",
    departure: "Fecha de Salida",
    message: "Mensaje",
    sendMessage: "Enviar",
    contact: "Contáctenos",
    address: "Primer restaurante a la izquierda",
    errName: "Por favor llene su nombre",
    errEmail: "Por favor introduzca un correo",
    errPhone: "Por favor denos un número de teléfono",
    errQuantity: "Por favor indiquenos cuanta gente sería",
    errArrival: "Indíquenos cuando llega",
    errDeparture: "Indíquenos cuando se va",
  },
  english: {
    title: "Bookings",
    name: "Name",
    email: "Email",
    phone: "Phone Number",
    quantity: "Quantity",
    arrival: "Arrival Date",
    departure: "Departure Date",
    message: "Message",
    sendMessage: "Send",
    contact: "Contact us",
    address: "First restaurant to your left",
    errName: "Please give us your name",
    errEmail: "Please give us an email",
    errPhone: "Please give us a phone number",
    errQuantity: "Please tell us how many people will be coming",
    errArrival: "Tell us when you are arriving",
    errDeparture: "Tell us when you are leaving",
  },
};

export default words;
